import qs, {StringifiableRecord} from 'query-string';
export const openDialogOutside = (dialogType: string, query?: StringifiableRecord) => {
   var strWindowFeatures = 'height=600,width=600,scrollbars=yes,status=yes';
   var URL = qs.stringifyUrl({url: `${window.location.origin}/dialog/${dialogType}`, query});
   var win = window.open(URL, '_blank', strWindowFeatures);
   return win;
   // console.debug(win);
};
